import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { UpdateVariableBenefitGoverningJurisdictionDetail } from './update-variable-benefit-governing-jurisdiction-detail';
import { VariableBenefitSourceJurisdiction } from './variable-benefit-source-jurisdiction';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';

export class UpdateVariableBenefitConfigurationSubmission implements Deserializable {
  public previous!: UpdateVariableBenefitConfigurationSubmissionData | null;
  public new!: UpdateVariableBenefitConfigurationSubmissionData | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.previous) {
      this.previous = Deserialize.instanceOf(UpdateVariableBenefitConfigurationSubmissionData, this.previous);
    }

    if (!!this.new) {
      this.new = Deserialize.instanceOf(UpdateVariableBenefitConfigurationSubmissionData, this.new);
    }
  }
}

export class UpdateVariableBenefitConfigurationSubmissionData implements Deserializable {
  public effectiveDate!: string | null;
  public estimatedNewCombinedVariableBenefitBalance!: number;
  public targetRecurringPaymentAmount!: number | null;
  public recurringPaymentFrequencyId!: number | null;
  public recurringPaymentStartDate!: string | null;
  public lumpSumPaymentDesiredPaymentDate!: string | null;
  public recurringPaymentFrequency!: BaseType | null;
  public governingJurisdictionOverrideId!: GoverningJurisdictionTypeId | null;
  public governingJurisdictionOverride!: GoverningJurisdictionType | null;
  public sourceJurisdictions!: VariableBenefitSourceJurisdiction[];
  public destinationJurisdictions!: UpdateVariableBenefitGoverningJurisdictionDetail[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.governingJurisdictionOverride) {
      this.governingJurisdictionOverride = Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdictionOverride
      );
    }

    if (!!this.sourceJurisdictions) {
      this.sourceJurisdictions = Deserialize.arrayOf(VariableBenefitSourceJurisdiction, this.sourceJurisdictions);
    }

    if (!!this.destinationJurisdictions) {
      this.destinationJurisdictions = Deserialize.arrayOf(
        UpdateVariableBenefitGoverningJurisdictionDetail,
        this.destinationJurisdictions
      );
    }
  }
}
